import { any, sortBy } from 'underscore';

import { Util } from 'app/scripts/lib/util';
import type { Membership } from './InviteMembership.types';

export const isValidEmail = (
  emailRestrictions: string[],
  text: string | undefined,
) => {
  if (emailRestrictions.length === 0) {
    return true;
  }

  if (!text) {
    return false;
  }

  return any(emailRestrictions, (restriction) =>
    new RegExp(
      `^${Util.escapeForRegex(restriction)?.replace(/\\\*/g, '[^@]*')}$`,
    ).test(text),
  );
};

export const simpleDomainRestriction = (restriction: string) => {
  if (/^\*@[^*]+$/.test(restriction)) {
    return restriction.replace(/^\*@/, '');
  } else {
    return null;
  }
};

export const sortBoardMembershipsByType = (
  memberships: Membership[],
  firstMemberId?: string,
) => {
  if (!memberships.length) {
    return [];
  }

  return sortBy(memberships, (membership) => {
    const { member } = membership;

    const status =
      firstMemberId && member.id === firstMemberId
        ? 'shouldListFirst'
        : member.memberType === 'ghost'
          ? 'pending'
          : membership.unconfirmed
            ? 'unconfirmed'
            : membership.deactivated
              ? 'deactivated'
              : membership.memberType === 'admin'
                ? 'admin'
                : (membership.orgMemberType ?? 'guest');

    // We add the `fullName` as the secondary comparison
    // function (e.g. members of the same type will be sorted
    // alphabetically)
    switch (status) {
      case 'shouldListFirst':
        // Exceptions if `firstMemberId` is declared
        return `0`;
      case 'admin':
        // Admins toward the front
        return `1`;
      case 'normal':
        return `2`;
      case 'deactivated':
        // Deactivated users always come last
        return `4`;
      default:
      case 'guest':
      case 'unconfirmed':
      case 'pending':
        return `3`;
    }
  });
};

export const HelperFunctions = {
  isValidEmail,
  simpleDomainRestriction,
  sortBoardMembershipsByType,
};
